{
  "messages": {
    "networkError": "เกิดข้อผิดพลาดของเครือข่าย หากปัญหายังคงอยู่ โปรดติดต่อเรา",
    "appointmentUpdatedValidationFailed": "อัปเดตการนัดหมายแล้ว แต่ไม่ผ่านการตรวจสอบภายนอก",
    "appointmentCreatedValidationFailed": "สร้างการนัดหมายแล้ว แต่ไม่ผ่านการตรวจสอบภายนอก",
    "validationErrorDetail": "<br /> ข้อผิดพลาดในการตรวจสอบ: {error}"
  },
  "titles": {
    "warehouseRuleFailed": "ไม่ผ่านกฎของคลังสินค้า",
    "validationServerError": "เซิร์ฟเวอร์ตรวจสอบเกิดข้อผิดพลาด",
    "appointmentUpdatedWithValidationError": "อัปเดตการนัดหมายแล้วแต่มีข้อผิดพลาดในการตรวจสอบ",
    "appointmentCreatedWithValidationError": "สร้างการนัดหมายแล้วแต่มีข้อผิดพลาดในการตรวจสอบ"
  }
}
